import React, {useMemo} from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {Box} from "@mui/material";

const DEFAULT_MODULES = {
    toolbar: [
        [{header: [1, 2, 3, false]}],
        ["bold", "italic", "underline", "strike"],
        [{list: "ordered"}, {list: "bullet"}],
        [{align: []}],
        ["link"],
        ["clean"],
    ],
};

const RichTextEditor = ({value, onChange, minHeight = 320, readOnly = false}) => {
    const modules = useMemo(() => DEFAULT_MODULES, []);

    return (
        <Box
            sx={{
                width: "100%",
                "& .ql-toolbar": {
                    borderRadius: "4px 4px 0 0",
                    borderColor: "#ccc",
                    fontFamily: "Roboto, sans-serif",
                },
                "& .ql-container": {
                    borderRadius: "0 0 4px 4px",
                    borderColor: "#ccc",
                    fontFamily: "Roboto, sans-serif",
                    fontSize: "1rem",
                },
                "& .ql-editor": {
                    minHeight: `${minHeight}px`,
                },
            }}
        >
            <ReactQuill
                theme="snow"
                value={value ?? ""}
                onChange={onChange}
                modules={modules}
                readOnly={readOnly}
            />
        </Box>
    );
};

export default RichTextEditor;
